import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'Store',
  components: {
    TimeComp: require('../../../components/time.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appData: {
        allocationId: -1,
        sourceType: '',
        sourceId: -1,
        scheduledDateTime: new Date(),
        scheduledTimeHH: 0,
        scheduledTimeMin: 0,
        itemId: -1,
        item: { itemId: -1, name: '' },
        itemsInventory: [],
        name: '',
        takenQuantity: 0,
        usedQuantity: 0,
        comment: '',
        sourceWareHouseId: 0,
        destinationWareHouseId: 0,
        readonly: false
      },
      emptyItem: '',
      showDate: { scheduledDateTime: false },
      disabledDates: date => {
        return (date < this.appData.scheduledDateTime);
      },
      scheduledDateTime: {},
      scheduledTime: { hours: 0, minutes: 0, descr: 'manpowers.ScheduledTime', isReadOnly: false },
    }
  },
  computed: {
    sourceWareHouse: function () {
      return this.appData.sourceWareHouseId;
    },
    item: function () {
      return this.appData.item;
    },
    formattedScheduledDateTime: {
      get: function () {
        return this.formatDateUI(moment(this.scheduledDateTime));
      },
      set: function (newValue) {
        //console.log('Setter => formattedScheduledDateTime: ');
        //console.log(newValue);
      }
    },
    scheduledTimeHours: function () {
      return this.scheduledTime.hours;
    },
    scheduledTimeMinutes: function () {
      return this.scheduledTime.minutes;
    },
  },
  watch: {
    sourceWareHouse: function (value) {
      this.getInventory();
    },
    scheduledTimeHours: function (value) {
      this.appData.scheduledTimeHH = value;
    },
    scheduledTimeMinutes: function (value) {
      this.appData.scheduledTimeMin = value;
    },
    item: function (value) {
      this.appData.itemId = value ? value.itemId : -1;
      this.$refs.select.open = false;
    },
    emptyItem: function (value) {
      this.appData.item = value ? value : this.appData.item;
      this.appData.itemId = value ? value.itemId : -1;
      this.$refs.select.open = false;
    },
  },
  created() {
    this.init();
    this.$root.$on('store_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.dataObj;
        var item = this.appData.itemsInventory.filter(inv => inv.itemId == this.appData.itemId)[0];
        this.appData.item = item ? item : this.appData.item;

        //this.scheduledDateTime = moment(this.appData.scheduledDateTime).subtract(1, 'days').format();
        this.scheduledTime.hours = this.appData.scheduledTimeHH;
        this.scheduledTime.minutes = this.appData.scheduledTimeMin;
      });
    },
    getInventory() {
      var parameter = {
        GroupId: 0,
        IsOnlyAvailableItems: true,
        WarehouseId: this.appData.sourceWareHouseId,
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: null }
      };
      axios.post('/Om/GetAvailableStoreItems', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.appData.itemsInventory = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
  },
}

